// extracted by mini-css-extract-plugin
export default {"detailsArea":"_4vPp1cZOvOsrJT6J43DVMA==","detailsAreaItem":"I8JAn49lIriT+STd7sQm9Q=="};